import { render, staticRenderFns } from "./TipTap.vue?vue&type=template&id=156717e0&scoped=true"
import script from "./TipTap.vue?vue&type=script&lang=js"
export * from "./TipTap.vue?vue&type=script&lang=js"
import style0 from "./TipTap.vue?vue&type=style&index=0&id=156717e0&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156717e0",
  null
  
)

export default component.exports